import React from 'react';

const CONFIG = {
    title: 'Status Events',
    columns: [
        { key: 'ts', label: 'Time' },
        { key: 'fw_ver', label: 'Firmware' },
        { key: 'idf_ver', label: 'IDF Ver' },
        { key: 'config_version', label: 'Config Ver', format: (val) => val ?? 0 },
        { key: 'hw', label: 'HW', format: (val) => val ?? '-' },
        { key: 'hw_rev', label: 'Rev', format: (val) => val ?? '-' },
        { key: 'temp', label: 'Temp', format: (val) => val?.toFixed(1) ?? '-' },
        { key: 't_max', label: 'Max', format: (val) => val?.toFixed(1) ?? '-' },
        { key: 't_min', label: 'Min', format: (val) => val?.toFixed(1) ?? '-' },
        { key: 'lux', label: 'Lux', format: (val) => val?.toFixed(0) ?? '-' },
        { key: 'l_max', label: 'Max', format: (val) => val?.toFixed(0) ?? '-' },
        { key: 'l_min', label: 'Min', format: (val) => val?.toFixed(0) ?? '-' },
    ],
};

function StatusTable({ items }) {
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <div className="tabular-data-container">
            <div className="table-section">
                <h3>{CONFIG.title}</h3>
                <table className="interference-table">
                    <thead>
                        <tr>
                            {CONFIG.columns.map((col) => (
                                <th key={col.key}>{col.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={index}>
                                {CONFIG.columns.map((col) => {
                                    let value = item[col.key];
                                    if (col.key === 'ts') {
                                        value = new Date(value).toLocaleString();
                                    } else if (col.format) {
                                        value = col.format(value);
                                    }
                                    return (
                                        <td key={col.key} data-label={col.label}>
                                            {value}
                                        </td>
                                    );
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default StatusTable;
